import { apiRequest } from './client';
import { env } from '../config/env';

export function fetchFulfillmentOrders(token, params = {}) {
  const query = new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(([, value]) => value != null && value !== '')
    )
  ).toString();
  return apiRequest(`/admin/fulfillment${query ? `?${query}` : ''}`, token);
}

export function lookupFulfillmentHawb(token, hawb) {
  const query = new URLSearchParams({ hawb: String(hawb || '').trim() }).toString();
  return apiRequest(`/admin/fulfillment/hawb?${query}`, token);
}

export function receiveFulfillmentHawb(token, hawb) {
  return apiRequest('/admin/fulfillment/hawb/receive', token, {
    method: 'POST',
    body: JSON.stringify({ hawb: String(hawb || '').trim() }),
  });
}

export function fetchItlBookingConfig(token) {
  return apiRequest('/admin/fulfillment/hawb/book-itl', token);
}

export function fetchItlCourierRates(token, hawb, { force = false, orderIds } = {}) {
  return apiRequest('/admin/fulfillment/hawb/itl-rates', token, {
    method: 'POST',
    body: JSON.stringify({
      hawb: String(hawb || '').trim(),
      force: Boolean(force),
      orderIds: Array.isArray(orderIds) ? orderIds : undefined,
    }),
  });
}

export function bookItlPacketsForHawb(
  token,
  hawb,
  { force = false, logistics, serviceType, orderIds } = {}
) {
  return apiRequest('/admin/fulfillment/hawb/book-itl', token, {
    method: 'POST',
    body: JSON.stringify({
      hawb: String(hawb || '').trim(),
      force: Boolean(force),
      logistics: logistics ? String(logistics) : undefined,
      serviceType: serviceType ? String(serviceType) : undefined,
      orderIds: Array.isArray(orderIds) ? orderIds : undefined,
    }),
  });
}

export async function downloadItlLabelsPdf(token, hawb, { orderIds } = {}) {
  const response = await fetch(`${env.apiBaseUrl}/admin/fulfillment/hawb/itl-labels`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      hawb: String(hawb || '').trim(),
      orderIds: Array.isArray(orderIds) ? orderIds : undefined,
    }),
  });

  if (
    response.status === 401 ||
    response.status === 403
  ) {
    const payload = await response.json().catch(() => ({}));
    const shouldForceSignOut =
      response.status === 401 ||
      (typeof payload.message === 'string' &&
        (payload.message.includes('deactivated') ||
          payload.message.includes('owner admin account is inactive')));
    if (shouldForceSignOut) {
      localStorage.removeItem('crmAuthToken');
      window.location.reload();
      return new Promise(() => {});
    }
    throw new Error(payload.message || 'Unable to download ITL shipping labels.');
  }

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.message || 'Unable to download ITL shipping labels.');
  }

  const blob = await response.blob();
  const filename = `ITL-labels-${String(hawb || 'hawb').trim()}.pdf`;
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  return { filename, size: blob.size };
}

export function cancelItlPacket(token, hawb, orderId) {
  return apiRequest('/admin/fulfillment/hawb/itl-cancel', token, {
    method: 'POST',
    body: JSON.stringify({
      hawb: String(hawb || '').trim(),
      orderId: String(orderId || '').trim(),
    }),
  });
}
